var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHexagon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 22.4975C11.8313 22.4975 11.6713 22.4575 11.5213 22.3675L3.27125 17.6975C2.97125 17.5275 2.78125 17.2075 2.78125 16.8575V7.1475C2.78125 6.7975 2.97125 6.4775 3.27125 6.3075L11.5213 1.6275C11.8213 1.4575 12.1812 1.4575 12.4812 1.6275L20.7312 6.2975C21.0312 6.4675 21.2212 6.7875 21.2212 7.1375V16.8475C21.2212 17.1975 21.0312 17.5175 20.7312 17.6875L12.4812 22.3575C12.3313 22.4375 12.1713 22.4875 12.0013 22.4875V22.4975ZM4.72125 16.2875L12.0013 20.4075L19.2812 16.2875V7.7075L12.0013 3.5875L4.72125 7.7075V16.2875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHexagon);
export default __webpack_public_path__ + "static/media/ic-hexagon.dd59464f1afcd4c71e60aa36ae56ac40.svg";
export { ForwardRef as ReactComponent };